import { initializeStore } from '@seamless/store';
import { connectionName as wkoConnectionName, WellKnownObjects } from '@owc/connection-wko-manager';
import { trackingService } from './lib/tracking';

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import FlyoutWrapper from './components/FlyoutWrapper/FlyoutWrapper.vue';
import { getTrackingDispatchers } from '@owc/connection-aem-tracking';
import { ABContext } from './lib/ABTestHelper';
Vue.config.ignoredElements.push(/wb-w*/);
@Component({
  components: {
    FlyoutWrapper,
  },
})
export default class App extends Vue {
  @Prop({ required: false, type: String }) private country!: string;
  @Prop({ required: false, type: String }) private language!: string;
  private storeCountry: string | undefined;
  private storeLanguage: string | undefined;
  private seamlessStore = initializeStore();
  // Here we get the instance for AB test Context
  private abContext = ABContext.initialize({ variableName: 'flyout', eventName: 'build' });
  private abTestValue = !!this.abContext.value;

  @Watch('abContext', { deep: true })
  abContextChangeHandler(): void {
    this.abTestValue = !!this.abContext.value;
  }
  created(): void {
    this.seamlessStore.subscribe(wkoConnectionName, (state: WellKnownObjects) => {
      this.storeCountry = state.Locale?.country;
      this.storeLanguage = state.Locale?.language;
    });
    this.abTestValue = !!this.abContext.value;
    getTrackingDispatchers().then((dispatcher) => trackingService.initializeTrackingDispatcher(dispatcher));
  }

  get computedCountry(): string {
    return this.country || this.storeCountry || 'DE';
  }

  get computedLanguage(): string {
    return this.language || this.storeLanguage || 'de';
  }
}
